/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
/* biome-ignore-all lint/performance/noNamespaceImport: Cleaner when working with libraries */
/* biome-ignore-all lint: TODO: Leaving these for esz-fortune and kermentrout to handle */
import { Slot } from '@radix-ui/react-slot';
import React from 'react';
import { tv, type VariantProps } from 'tailwind-variants';
import { cn } from '@/app_lib/utils/utils';

export const input = tv({
  base: 'input',
  defaultVariants: {
    sizes: 'sm',
  },
  variants: {
    sizes: {
      lg: 'input-lg',
      sm: 'input-sm',
    },
    variant: {
      error: 'input-error',
      primary: 'input-primary',
    },
  },
});

type InputVariants = VariantProps<typeof input>;

interface InputProps extends InputVariants, React.InputHTMLAttributes<HTMLInputElement> {
  asChild?: boolean;
  className?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, sizes, asChild = false, ...rest }, ref) => {
    const Comp = asChild ? Slot : 'input';
    return (
      <Comp
        className={cn(input({ sizes, variant }), className)}
        ref={ref}
        {...rest}
      />
    );
  },
);

Input.displayName = 'Input';

export { Input };
